import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("wf_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default api;

export function fmtError(detail) {
  if (detail == null) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

/**
 * Turn a stored selfie reference into a fully-qualified URL that <img> tags can render.
 * Accepts:
 *   - null / undefined  → returns null
 *   - `data:image/...` (legacy inline b64) → returned unchanged
 *   - `/api/media/...` (new reference)     → prefixed with backend URL + auth token query
 *   - anything else → returned unchanged (defensive)
 */
export function mediaUrl(ref) {
  if (!ref) return null;
  if (typeof ref !== "string") return null;
  if (ref.startsWith("data:")) return ref;
  if (ref.startsWith("/api/media/")) {
    const token = localStorage.getItem("wf_token");
    const sep = ref.includes("?") ? "&" : "?";
    return `${BACKEND_URL}${ref}${token ? `${sep}t=${encodeURIComponent(token)}` : ""}`;
  }
  return ref;
}
